
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFilter3On as ObiFilter3OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-filter-3-on.js';
 
 
 

 
 export const ObiFilter3On = createComponent({
   react: React,
   tagName: 'obi-filter-3-on',
   elementClass: ObiFilter3OnElement,
   events: {
     
   }
  });
 
 